import {
  Ban,
  CircleCheck,
  CircleOff,
  OctagonAlert,
  RefreshCw,
  ShieldAlert,
  TriangleAlert,
  Wrench,
} from 'lucide-react';
import type { DeviceStatus, EventSeverity } from '../types';
import { severityLabels, statusLabels } from '../utils/format';

const statusIcons = {
  online: CircleCheck,
  offline: CircleOff,
  warning: TriangleAlert,
  critical: OctagonAlert,
  maintenance: Wrench,
  disabled: Ban,
  updating: RefreshCw,
  unauthorized: ShieldAlert,
};

export function StatusBadge({ status, compact = false }: { status: DeviceStatus; compact?: boolean }) {
  const Icon = statusIcons[status];
  return (
    <span className={`status-badge status-badge--${status} ${compact ? 'status-badge--compact' : ''}`}>
      <Icon size={14} strokeWidth={2.2} aria-hidden="true" />
      <span>{statusLabels[status]}</span>
    </span>
  );
}

export function SeverityBadge({ severity }: { severity: EventSeverity }) {
  const mappedStatus: DeviceStatus =
    severity === 'info' ? 'updating' : severity === 'online' ? 'online' : severity;
  const Icon = statusIcons[mappedStatus];
  return (
    <span className={`status-badge status-badge--${mappedStatus}`}>
      <Icon size={14} strokeWidth={2.2} aria-hidden="true" />
      <span>{severityLabels[severity]}</span>
    </span>
  );
}
